import { makeStyles } from '@material-ui/core';
import React from 'react';

let useStyles = makeStyles(() => ({
    root: {
        width: 16,
        height: 4,
        backgroundColor: "#DA212E",
        border: 'none',
        display: 'inline-block',
        position: 'absolute',
        // width: 9,
        // height: 9,
        display: "block",
        margin: "auto",
        // position: "absolute",
        top: "50% " ,/* position the top  edge of the element at the middle of the parent */
        left: "-5%", /* position the left edge of the element at the middle of the parent */
    
        transform: "translate(-50%, -50%)"
    }
}))


export default function LineIcons() {

    let classes = useStyles();

    return <span className={classes['root']} />;
}
